import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
// import './registerServiceWorker'
import router from './router'
import store from './store'

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: 'red',
  failedColor: 'yellow',
  thickness: '4px',
  position: 'absolute',
  autoFinish: false,
})

import './assets/styles/index.css';

// require('./firebase');

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
